import { Injectable } from '@angular/core';
import {
  Step,
  StepAction,
  StepType
} from 'src/app/features/chat-bot/types/steps.type';

@Injectable({
  providedIn: 'root'
})
export class StepApiDataPreparationService {
  prepareApiData(step: Step, option: StepAction, currentLang: string): void {
    if (!step.api) return;

    switch (step.type) {
      case StepType.ONLINE_REVIEW:
        this.prepareOnlineReviewData(step, option);
        break;

      case StepType.CONTACT_FORM_EXTERNAL:
        this.prepareContactFormExternalData(step, currentLang);
        break;

      case StepType.EXTERNAL_LANDING_PAGE:
        this.prepareExternalLandingPageData(step, option, currentLang);
        break;

      default:
        this.prepareDefaultConditionValue(step, option);
        break;
    }
  }

  private prepareOnlineReviewData(step: Step, option: StepAction): void {
    if (!step.api?.data || step.type !== StepType.ONLINE_REVIEW) return;

    if (option.action.platform) {
      step.api.data.selected_platform = option.action.platform;
    } else if (!option.action.redirect) {
      step.api.data.selected_platform = 'declined';
    }

    if (typeof option.action.redirect === 'string') {
      step.api.data.redirect_url = option.action.redirect || '';
    }
  }

  private prepareContactFormExternalData(
    step: Step,
    currentLang: string
  ): void {
    if (!step.api?.data || step.type !== StepType.CONTACT_FORM_EXTERNAL) return;

    const stepData = step.api.data as any;

    if (stepData.redirect_url && typeof stepData.redirect_url === 'object') {
      const currentLanguageUrl = stepData.redirect_url[currentLang];
      if (currentLanguageUrl) {
        stepData.redirect_url = currentLanguageUrl;
      }
    }
  }

  private prepareExternalLandingPageData(
    step: Step,
    option: StepAction,
    currentLang: string
  ): void {
    if (
      !step.api?.data ||
      step.type !== StepType.EXTERNAL_LANDING_PAGE ||
      typeof option.action.redirect !== 'object' ||
      option.action.redirect === null
    ) {
      return;
    }

    step.api.data.landing_page_url = option.action.redirect[currentLang];
  }

  private prepareDefaultConditionValue(step: Step, option: StepAction): void {
    if (
      step.api?.data &&
      'condition_value' in step.api.data &&
      step.type !== StepType.EMPLOYEE_SELECTION
    ) {
      step.api.data.condition_value = option.condition_value;
    }
  }
}
